//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { Box, Link, Typography } from '@mui/material';
import { useConfig } from '@/hooks/useConfig';
import { ERoutesRoot } from '@/routes/RoutesEnum';

interface FooterProps {
  hidden?: boolean;
}

const Footer = ({ hidden }: FooterProps) => {
  const { appConfig } = useConfig();
  const version = appConfig?.version || '';

  return (
    <Box component="footer" sx={{ display: hidden ? 'none' : 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 1, py: 2, px: 2 }}>
      {/* Footer content */}
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        &copy; 2024-2026 Trovares, Inc. dba Rocketgraph.  All rights reserved.
      </Typography>
      <Box sx={{ ml: 2 }}>  {/* Add some margin between elements */}
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          <Link
            href={ERoutesRoot.TermsOfUse}
            underline="none"
            sx={{
              color: 'text.secondary',

              '&: hover': {
                textDecoration: 'underline',
              }
            }}>
            Terms of Use
          </Link>
        </Typography>
      </Box>
      <Box sx={{ ml: 2 }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Version {version}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
